import React, { useState, useEffect } from "react";
import { Provider } from "react-redux";

// Pages
import Home from "./Page/Home/Home";

// Components
import AxL from "./axl";
import { AxLProvider, useAxL } from "./AxLContext";

// Store
import store from "./store";

const App = () => {
  const [gameVisible, setGameVisible] = useState(false);
  const axl = useAxL();

  useEffect(() => {
    if (window._y010) {
      setGameVisible(true);
    } else {
      initAxL();
    }
  }, []);

  const initAxL = async () => {
    const gotFirstResume = new Promise((resolve) => {
      axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
                resolve();
      });
    });

    const gameReady = axl.handshake().then((initialData) => {
      try {
        let objJsonStr = JSON.stringify(initialData);
        let objJsonB64 = Buffer.from(objJsonStr).toString("base64");
      } catch (error) {
        console.log("ERROR", error);
      }
    });

    Promise.all([gotFirstResume, gameReady]).then(() => {
      setGameVisible(true);
    });
  };

  return (
    <Provider store={store}>
      <AxLProvider>{gameVisible ? <Home /> : <></>}</AxLProvider>
    </Provider>
  );
};

export default App;
